import { render, staticRenderFns } from "./EditBike.vue?vue&type=template&id=2a2ceb3a"
import script from "./EditBike.vue?vue&type=script&lang=js"
export * from "./EditBike.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports